<script>
	import { getContext, onMount } from "svelte";

	const getTimeline = getContext("getTimeline");
	const getDuration = getContext("getDuration");
	const getEasing = getContext("getEasing");

	// position the element

	export let left = "";
	export let top = "";

	export let anchor = "center"; // "center", "top", "topright,

	$: translateAnchorX = anchor.indexOf("left") !== -1 ? "0" : anchor.indexOf("right") !== -1 ? "-100%" : "-50%";
	$: translateAnchorY = anchor.indexOf("top") !== -1 ? "0" : anchor.indexOf("bottom") !== -1 ? "-100%" : "-50%";

	// set to initial values of animation, for prerendering

	export let animation = {};

	const translateX = animation.translateX ? animation.translateX[0] : 0;
	const translateY = animation.translateY ? animation.translateY[0] : 0;
	const opacity = animation.opacity ? animation.opacity[0] : 1;

	function fixEasing(e) {
		return e.replace("-b", "B").replace("-i", "I").replace("-o", "O");
	}

	// handle delay and shorter duration

	const properties = ["translateX", "translateY", "opacity"];

	properties.forEach((p) => {
		if (animation[p] && animation[p][0] === undefined) {
			const ts = Object.keys(animation[p]).sort();
			const mint = ts[0];
			animation[p][0] = animation[p][mint];
		}
	});

	properties.forEach((p) => {
		if (animation[p] && animation[p][1] === undefined) {
			const ts = Object.keys(animation[p]).sort().reverse();
			const mint = ts[0];
			animation[p][1] = animation[p][mint];
		}
	});

	// when mounted, register at the parent Animation component's timeline

	let elemInner;

	onMount(() => {
		// b/c of mounting order :(
		setTimeout(() => {
			const timeline = getTimeline();
			const duration = getDuration();
			let easing = getEasing();

			if (animation.easing) easing = animation.easing;

			const a = {
				targets: elemInner,
				easing: fixEasing(easing),
			};

			properties.forEach((p) => {
				if (!animation[p]) return;

				a[p] = [];
				let lastT = null;
				const ts = Object.keys(animation[p]);
				ts.sort();
				ts.forEach((t) => {
					const durationKf = lastT !== null ? (t - lastT) * duration : 0;
					const value = typeof animation[p][t] === "object" ? animation[p][t].value : animation[p][t];
					const easingKf =
						typeof animation[p][t] === "object" && animation[p][t].easing ? animation[p][t].easing : easing;

					const kf = {
						value,
						duration: durationKf,
						easing: fixEasing(easingKf),
					};

					a[p].push(kf);
					lastT = t;
				});

				timeline.add(a, 0);
			});
		});

		// TODO jeweils easing
	});
</script>

<div class="animatable" style:left style:top style:transform="translate({translateAnchorX}, {translateAnchorY})">
	<div
		bind:this={elemInner}
		class="animatable-inner"
		style:transform="translateX({translateX}) translateY({translateY})"
		style:opacity
	>
		<slot />
	</div>
</div>

<style lang="scss">
	.animatable {
		width: fit-content;
		height: fit-content;
		position: absolute;
	}
	.animatable-inner {
		will-change: transform;
	}
</style>
